export default __webpack_public_path__ + "img/intro-aciqui.84c7af50.png";